export const primary = '#3B2FD7';
export const primaryDark = '#12131C';
export const primaryLight = '#3B2FD7';
export const background = '#F8F8F8';
export const paper = '#fff';
export const text = '#000000';
